import * as React from "react"

const SvgDeviceDesktop = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M10 19.571v-2H4q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 15.57v-10q0-.824.587-1.412A1.93 1.93 0 0 1 4 3.57h16q.824 0 1.413.588Q22 4.746 22 5.57v10a1.93 1.93 0 0 1-.587 1.413A1.93 1.93 0 0 1 20 17.57h-6v2h1a.97.97 0 0 1 .713.288q.287.289.287.712a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287H9a.97.97 0 0 1-.713-.287A.97.97 0 0 1 8 20.57a.97.97 0 0 1 .287-.712A.97.97 0 0 1 9 19.57h1Zm-6-4h16v-10H4z" />
  </svg>
)
export default SvgDeviceDesktop
